import { render, staticRenderFns } from "./latestNotifications.vue?vue&type=template&id=cd287f22"
import script from "./latestNotifications.vue?vue&type=script&lang=js"
export * from "./latestNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd287f22')) {
      api.createRecord('cd287f22', component.options)
    } else {
      api.reload('cd287f22', component.options)
    }
    module.hot.accept("./latestNotifications.vue?vue&type=template&id=cd287f22", function () {
      api.rerender('cd287f22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/widgets/latestNotifications.vue"
export default component.exports